/**
 * Mobile Viewport Height Fix
 * 
 * Fixes the mobile browser viewport height issue where 100vh includes
 * browser chrome (address bar, navigation bar), causing pages to wobble
 * when the browser chrome shows/hides.
 * 
 * This script sets a CSS custom property --vh that represents the actual
 * viewport height excluding browser chrome.
 */

export const initViewportFix = () => {
  // Function to set the viewport height
  const setViewportHeight = () => {
    // Get the actual viewport height
    const vh = window.innerHeight * 0.01;
    // Set the CSS custom property
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  };

  // Set initial value
  setViewportHeight();

  // Update on resize and orientation change with debouncing
  let resizeTimer = null;
  const debouncedSetViewportHeight = () => {
    if (resizeTimer) {
      clearTimeout(resizeTimer);
    }
    resizeTimer = setTimeout(setViewportHeight, 100);
  };
  
  window.addEventListener('resize', debouncedSetViewportHeight);
  window.addEventListener('orientationchange', () => {
    // Small delay to ensure accurate height after orientation change
    setTimeout(setViewportHeight, 100);
  });

  // Update when viewport changes (for mobile browsers that show/hide chrome)
  let lastHeight = window.innerHeight;
  const checkHeight = () => {
    const currentHeight = window.innerHeight;
    if (Math.abs(currentHeight - lastHeight) > 50) {
      // Significant height change detected (likely browser chrome show/hide)
      setViewportHeight();
      lastHeight = currentHeight;
    }
  };

  // Check periodically for viewport changes
  setInterval(checkHeight, 150);

  // Also listen to visual viewport API if available (more accurate)
  if (window.visualViewport) {
    let visualResizeTimer = null;
    let visualScrollTimer = null;
    
    const debouncedVisualViewportResize = () => {
      if (visualResizeTimer) {
        clearTimeout(visualResizeTimer);
      }
      visualResizeTimer = setTimeout(setViewportHeight, 50);
    };
    
    const debouncedVisualViewportScroll = () => {
      if (visualScrollTimer) {
        clearTimeout(visualScrollTimer);
      }
      visualScrollTimer = setTimeout(setViewportHeight, 50);
    };
    
    window.visualViewport.addEventListener('resize', debouncedVisualViewportResize);
    window.visualViewport.addEventListener('scroll', debouncedVisualViewportScroll);
  }
};

